import { StepCommandType } from 'containers/Project/ProjectData/sideBar/steps';
import { create } from 'zustand';

interface PreprocessStoreType {
  isAutoUpdateMode: boolean;
  isOnlyFilterViewMode: boolean;
  updateDebounceTime: number;
  preprocessMode: StepCommandType;
  preprocessTargetColumn: string;
  preprocessTargetColumnList: string[]; // 해당 전처리 모드를 실행시킨 컬럼명
  isFilterView: boolean;
  columnSelectMode: boolean;
  singleColumnSelectMode: boolean;
  isExceptFilter: boolean;
  setIsAutoUpdateMode: (value: boolean) => void;
  setIsOnlyFilterViewMode: (value: boolean) => void;
  setIsUpdateDebounceTime: (timeout: number) => void;
  setPreprocessTargetColumn: (columnName: string) => void;
  setPreprocessTargetColumnList: (list: string[]) => void;
  setPreprocessMode: (mode: StepCommandType) => void;
  setIsFilterView: (view: boolean) => void;
  setColumnSelectMode: (value: boolean) => void;
  setSingleColumnSelectMode: (value: boolean) => void;
  setExceptFilter: (value: boolean) => void;
  resetPreprocessStore: () => void;
}

const usePreprocessStore = create<PreprocessStoreType>((set, get) => ({
  isAutoUpdateMode: false,
  isOnlyFilterViewMode: false,
  updateDebounceTime: 1000,
  preprocessMode: null,
  preprocessTargetColumn: '',
  preprocessTargetColumnList: [],
  isFilterView: false,
  columnSelectMode: false,
  singleColumnSelectMode: false,
  isExceptFilter: false,
  setIsAutoUpdateMode: (value: boolean) => {
    set({ isAutoUpdateMode: value });
  },
  setIsOnlyFilterViewMode: (value: boolean) => {
    set({ isOnlyFilterViewMode: value });
  },
  setIsUpdateDebounceTime: (timeout: number) => {
    set({ updateDebounceTime: timeout });
  },
  setPreprocessTargetColumn: (columnName: string) => {
    const { preprocessTargetColumn } = get();
    if (preprocessTargetColumn !== columnName) {
      set({ preprocessTargetColumn: columnName });
    }
  },
  setPreprocessTargetColumnList: (list: string[]) => {
    set({ preprocessTargetColumnList: list });
  },
  setPreprocessMode: (mode: StepCommandType) => {
    set((state) => ({
      ...state,
      preprocessMode: mode,
      // targetColumnList: column ? [column] : [],
    }));
  },
  setIsFilterView: (view: boolean) => {
    set({ isFilterView: view });
  },
  setColumnSelectMode: (value: boolean) => {
    set({ columnSelectMode: value });
  },
  setSingleColumnSelectMode: (value: boolean) => {
    set({ singleColumnSelectMode: value });
  },
  setExceptFilter: (value: boolean) => {
    set({ isExceptFilter: value });
  },
  resetPreprocessStore: () => {
    set((state) => ({
      ...state,
      // isAutoUpdateMode: false,
      isOnlyFilterViewMode: false,
      preprocessMode: null,
      preprocessTargetColumn: '',
      preprocessTargetColumnList: [],
    }));
  },
}));

export default usePreprocessStore;
